import { setDirections, setDirectionsPanel, setShowQRFrame, } from '../../../../../store/uislice';
import { store } from '../../../../../store/store';
import { getContext, getLocation, setSelectedLocation, } from '../../../redux/spaces-slice';
import { resolveWhereAmIFloor } from '../../util/where-am-i';
import { sendTrackingEventForGetDirectionsClick } from '../../util';
import { invokeRichMapMethod } from './rich-map';
const startDirections = ({ currentFloorLocationId, deviceFloorNumber, deviceLocationId, drawingOnMap, richMapId, roomFloorNumber, roomName, tenantId, }) => {
    const hasCurrentSource = () => {
        const state = store.getState();
        const floor = resolveWhereAmIFloor(getLocation(state), getContext(state));
        return ((floor === null || floor === void 0 ? void 0 : floor.id) === deviceLocationId &&
            Number(floor === null || floor === void 0 ? void 0 : floor.floorNumber) === deviceFloorNumber);
    };
    if (!richMapId || !drawingOnMap || !hasCurrentSource()) {
        return;
    }
    store.dispatch(setShowQRFrame({ payload: false }));
    store.dispatch(setDirections({ payload: null }));
    sendTrackingEventForGetDirectionsClick(richMapId, tenantId);
    if (drawingOnMap && roomFloorNumber !== deviceFloorNumber) {
        // Store the real rich map id (still used verbatim for rMap.navigate) plus
        // the authoritative name/floor so the stepper renders from these instead of
        // splitting the rich map id.
        store.dispatch(setDirectionsPanel({
            payload: {
                richMapId,
                name: roomName !== null && roomName !== void 0 ? roomName : null,
                floorNumber: roomFloorNumber,
            },
        }));
        if (deviceLocationId &&
            currentFloorLocationId &&
            currentFloorLocationId !== deviceLocationId) {
            store.dispatch(setSelectedLocation(deviceLocationId));
        }
        return;
    }
    if (!drawingOnMap) {
        return;
    }
    invokeRichMapMethod('reset');
    window.setTimeout(() => {
        if (!hasCurrentSource())
            return;
        invokeRichMapMethod('navigate', richMapId);
    }, 200);
};
export { startDirections };
